import { ReactComponent as ChevronRightIcon } from '../../../icons/svg/arrow/arrow-chevron-right.svg';
import { ReactComponent as CloseIcon } from '../../../icons/svg/close.svg';
import { RoccoLink } from '../../../components/link/RoccoLink';
import type { HeaderNavLinks } from './Header';
import { useState } from 'react';

interface MobileNavMenuProps {
    primaryLinks: HeaderNavLinks;
    secondaryLinks: HeaderNavLinks;
    isAuthorized: boolean;
    close: () => void;
    currentUrl: string;
    logout: () => void;
}

export const MobileNavMenu = (props: MobileNavMenuProps) => {
    const {
        primaryLinks,
        secondaryLinks,
        close,
        isAuthorized,
        currentUrl,
        logout,
    } = props;

    const encodedRedirect = encodeURIComponent(currentUrl);
    const [logoutClicked, setLogoutClicked] = useState(false);
    const [clickedLink, setClickedLink] = useState<string | null>(null);

    // Check if a specific link is being navigated to
    const isNavigatingTo = (path: string) => {
        return clickedLink === path;
    };

    const handleLinkClick = (path: string) => {
        setClickedLink(path);
    };

    const isLoggingOut = logoutClicked;

    const handleLogout = () => {
        setLogoutClicked(true);
        logout();
    };

    return (
        <div className="scrollbar-hide h-screen overflow-y-scroll overscroll-y-none bg-gray-50">
            <main className="min-h-screen w-screen overscroll-y-none px-6">
                <div className="py-6">
                    <CloseIcon
                        role="button"
                        onClick={close}
                        aria-label="Close Navigation Menu"
                    />
                </div>
                <nav>
                    <ul className="flex flex-col">
                        {primaryLinks.links.map((item) => (
                            <li
                                key={item.title}
                                className={`px-4 ${isNavigatingTo(item.to) ? '-mx-6 bg-[#E8E7E7]/50' : ''}`}
                            >
                                <RoccoLink
                                    className={`flex items-center justify-between py-2 text-8 leading-[1.3] text-black hover:text-black ${isNavigatingTo(item.to) ? 'px-6' : ''}`}
                                    to={item.to}
                                    prefetch="viewport"
                                    isNonRemixRoute={item.isNonRemixRoute}
                                    onClick={() => handleLinkClick(item.to)}
                                >
                                    {item.title}
                                    <ChevronRightIcon className="size-5" />
                                </RoccoLink>
                            </li>
                        ))}
                    </ul>
                    <ul className="mt-11 flex flex-col gap-3">
                        {secondaryLinks.links.map((item) => (
                            <li key={item.title}>
                                <RoccoLink
                                    className={`inline-block px-4 py-2 text-lg tracking-wide text-gray-400 hover:text-black ${
                                        isNavigatingTo(item.to) &&
                                        'rounded-full bg-gray-100/80 text-black'
                                    }`}
                                    to={item.to}
                                    isNonRemixRoute={item.isNonRemixRoute}
                                    onClick={() => handleLinkClick(item.to)}
                                >
                                    {item.title}
                                </RoccoLink>
                            </li>
                        ))}
                    </ul>
                </nav>
                <section className="mt-12 flex justify-between gap-2">
                    {isAuthorized ? (
                        // This style of button is only used once in the app for now
                        <button
                            className={`flex-1 rounded-full border border-black py-4 text-center text-lg tracking-wide ${
                                isLoggingOut
                                    ? 'bg-black text-white'
                                    : 'bg-transparent text-black'
                            }`}
                            onClick={handleLogout}
                            disabled={isLoggingOut}
                        >
                            Log out
                        </button>
                    ) : (
                        <>
                            <RoccoLink
                                className="flex-1 rounded-full border border-black bg-transparent py-4 text-center text-lg tracking-wide text-black"
                                to={`/login?redirect=${encodedRedirect}`}
                                onClick={() =>
                                    handleLinkClick(
                                        `/login?redirect=${encodedRedirect}`,
                                    )
                                }
                            >
                                Log in
                            </RoccoLink>

                            <RoccoLink
                                className="flex-1 rounded-full border border-white bg-black py-4 text-center text-lg tracking-wide text-white"
                                to={`/login?redirect=${encodedRedirect}`}
                                onClick={() =>
                                    handleLinkClick(
                                        `/login?redirect=${encodedRedirect}`,
                                    )
                                }
                            >
                                Sign up
                            </RoccoLink>
                        </>
                    )}
                </section>
            </main>

            {/*sometime the nav menu of mobile browser will float on bottom*/}
            {/*this component is to take the place*/}
            <div className="h-24"></div>
        </div>
    );
};
